import React, { Fragment } from "react";
import { TERMS } from "../../enums/termsAndConditions";
import { Head } from "@inertiajs/react";

const TermsAndConditionsPage = () => {
  return (
    <Fragment>
      <Head>
        <title>Terms of Service </title>
        <meta name="description" content="Terms of Service for WannaCollab." />
      </Head>
      {TERMS}
    </Fragment>
  );
};

export default TermsAndConditionsPage;